<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :width="_width" 
    :height="_height"
    :spin="spin"
    :rtl="rtl"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    role="presentation"
    ref="host"
  >
    <g><defs><clipPath id="15c5d5__a"><rect rx="0" height="24" width="24"/></clipPath></defs><g clip-path="url(#15c5d5__a)" fill="#333" fill-rule="evenodd"><path style="mix-blend-mode: passthrough" d="M17.613 8.296v.945h.003q0 .049.01.096.009.048.027.093.019.045.046.086.027.04.062.075.034.034.075.061.04.028.085.046.045.019.093.028.048.01.097.01.048 0 .096-.01t.093-.028q.045-.018.086-.046.04-.027.075-.061.034-.035.061-.075.027-.04.046-.086.019-.045.028-.093.01-.047.01-.096h.002v-.945q0-2.157-1.475-3.684-1.482-1.535-3.582-1.535-2.288 0-3.73 1.683-1.44-1.685-3.73-1.683-2.1 0-3.582 1.535-1.475 1.527-1.475 3.684 0 3.404 3.195 6.745 2.662 2.784 5.43 3.737.097.033.199.026.101-.008.192-.055l1.184-.614v-.002q.06-.031.11-.078.049-.046.084-.104.036-.058.054-.124.018-.065.018-.133 0-.05-.01-.097-.009-.048-.027-.093-.019-.045-.046-.085-.027-.04-.062-.075-.034-.035-.075-.062-.04-.027-.085-.046-.045-.018-.093-.028-.048-.01-.097-.01-.12 0-.227.056l-.001-.002-.992.514q-2.44-.905-4.837-3.412-2.919-3.053-2.919-6.058 0-1.755 1.196-2.993Q4.414 4.072 6.09 4.072q2.106-.002 3.32 1.787.053.08.132.133.081.055.178.075.097.02.194.002.098-.019.18-.073.083-.054.138-.136 1.216-1.788 3.32-1.788 1.677 0 2.866 1.23 1.195 1.239 1.195 2.994Z" data-follow-fill="#333" :fill="_fill"/><path style="mix-blend-mode: passthrough" d="M15.9 9.995q1.167-1.252 2.984-1.252 1.716 0 2.93 1.209 1.215 1.21 1.215 2.92 0 2.67-2.59 5.275-2.146 2.159-4.383 2.899-.156.051-.312 0-2.236-.74-4.383-2.899-2.59-2.604-2.59-5.275 0-1.71 1.215-2.92 1.214-1.21 2.93-1.21 1.819 0 2.985 1.253Zm-2.984-.257q1.637-.002 2.578 1.332.05.07.12.12.04.028.084.048.045.02.092.03.048.011.097.013.049 0 .097-.007.049-.009.094-.026.046-.018.087-.044.042-.026.077-.06.036-.033.064-.073.943-1.333 2.578-1.333 1.306 0 2.229.918.921.918.921 2.216 0 2.26-2.3 4.574-1.902 1.913-3.834 2.602-1.931-.69-3.833-2.602-2.301-2.313-2.301-4.574 0-1.298.922-2.216.923-.918 2.228-.918Z" data-follow-fill="#333" :fill="_fill"/></g></g>
  </svg>
</template>

<script lang="ts">
import { Vue, prop } from 'vue-class-component';

class Props {
    width = prop<number | string>({
      type: [Number, String],
      required: false
    })
    
    height = prop<number | string>({
      type: [Number, String],
      required: false
    })
    
    stroke = prop<string>({
      type: String,
      required: false
    })
    
    fill = prop<string>({
      type: String,
      required: false
    })
    
    color = prop<string>({
      type: String,
      required: false
    })
    
    spin = prop<boolean>({
      type: Boolean,
      required: false
    })
    
    rtl = prop<boolean>({
      type: Boolean,
      required: false
    })
    

  // optional prop with default
  size = prop<number | string>({ default: '1em' })
}

export default class Shuangaixin extends Vue.with(Props) {
    get _fill(): string | undefined {
        return this.fill || this.color
    }
    get _stroke(): string | undefined {
        return this.stroke || this.color
    }
    get _width(): string | number {
      return this.width || this.size
    }
    get _height(): string | number {
      return this.height || this.size
    }
  mounted():void {
        if (!this._fill) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-fill]').forEach(item => {
            item.setAttribute('fill', item.getAttribute('data-follow-fill') || '')
            })
        }
        if (!this._stroke) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-stroke]').forEach(item => {
            item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '')
            })
        }
    }
    updated():void {
        if (!this._fill) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-fill]').forEach(item => {
            item.setAttribute('fill', item.getAttribute('data-follow-fill') || '')
            })
        }
        if (!this._stroke) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-stroke]').forEach(item => {
            item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '')
            })
        }
    }
}
</script>

<style scoped>
svg[spin="true"] {animation: iconpark-spin 1s infinite linear;}

svg[spin="true"][rtl="true"] {animation: iconpark-spin-rtl 1s infinite linear;}

svg[rtl="true"] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% { -webkit-transform: rotate(0); transform: rotate(0);}

 100% {-webkit-transform: rotate(360deg); transform: rotate(360deg);}
}
@keyframes iconpark-spin-rtl {
  0% {-webkit-transform: scaleX(-1) rotate(0); transform: scaleX(-1) rotate(0);}

 100% {-webkit-transform: scaleX(-1) rotate(360deg); transform: scaleX(-1) rotate(360deg);}
}
</style>
